import AuthContentWrapper from "./components/AuthContentWrapper";
import CustomIcon from "../../common/components/image/CustomIcon";
import { Column, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import { Theme } from "../../common/Theme";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import CustomRadios from "../../common/components/radio/CustomRadios";
import CustomInput from "../../common/components/input/CustomInput";
import { useEffect, useState } from "react";
import CustomPopup from "../../common/components/popup/CustomPopup";
import Translate from "../../common/translate/Translate";
import AuthService from "../../service/AuthService";
import LMPAuthApi from "../../api/lmp/LMPAuthApi";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import FranchiseService from "../../service/FranchiseService";
import UserService from "../../service/UserService";
import LMPAuthUtils from "../../api/lmp/LMPAuthUtils";

function RoleChoicePage() {
    const service = new AuthService();
    const userService = new UserService();
    const franchiseService = new FranchiseService();
    const api = new LMPAuthApi();
    const [isFranchise, setIsFranchise] = useState("n");
    const [franchiseCode, setFranchiseCode] = useState("");
    const [userType, setUserType] = useState("franchiseAdmin");

    // Cancel Podal
    const [isErrorText, setIsErrorText] = useState(true);
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };
    const redirectToLMPLogin = () => {
        const serverCountry = localStorage.getItem(LocalStorageKey.server) || "TH";
        window.location.href = LMPAuthUtils.getLoginUrl({ serverCountry });
    };
    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);
        redirectToLMPLogin();
    };

    // Error Popup
    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState(false);

    const handleChangeRole = () => {
        if (isFranchise === "y") {
            franchiseService
                .checkFranchiseCode({
                    countryCode: localStorage.getItem(LocalStorageKey.server),
                    franchiseCode: franchiseCode,
                })
                .then((resp) => {
                    console.log("resp: ", resp);
                    if (resp.franchiseCode === undefined) {
                        // setIsErrorPopupOpen(true);
                        setIsErrorText(false);
                    } else {
                        let roleId = localStorage.getItem(LocalStorageKey.server) + franchiseCode + "03703";
                        if (userType === "franchiseAdmin") {
                            roleId = localStorage.getItem(LocalStorageKey.server) + franchiseCode + "03701";
                        } else if (userType === "callCenter") {
                            roleId = localStorage.getItem(LocalStorageKey.server) + franchiseCode + "03702";
                        }

                        api.changeRole({
                            accessToken: localStorage.getItem(LocalStorageKey.accessToken),
                            roleId: roleId,
                        }).then(() => {
                            userService.putFranchiseUser({ franchise_join_status: "accepted" });
                        });
                        localStorage.removeItem(LocalStorageKey.accessToken);
                        localStorage.removeItem(LocalStorageKey.refreshToken);
                        redirectToLMPLogin();
                    }
                })
                .catch((err) => {
                    // setIsErrorPopupOpen(true);
                    setIsErrorText(false);
                });
        } else {
            api.changeRole({
                accessToken: localStorage.getItem(LocalStorageKey.accessToken),
                roleId: "USR037001",
            }).then(() => {
                userService.putFranchiseUser({ franchise_join_status: "declined" });
                localStorage.removeItem(LocalStorageKey.accessToken);
                localStorage.removeItem(LocalStorageKey.refreshToken);
                redirectToLMPLogin();
            });
        }
    };

    useEffect(() => {
        userService.putFranchiseUser({ franchise_join_status: "declined" });

        const prevServer = localStorage.getItem(LocalStorageKey.server);
        localStorage.setItem(LocalStorageKey.server, "KR");
        const krService = new AuthService();
        const krApi = new LMPAuthApi();
        if (prevServer !== null) {
            localStorage.setItem(LocalStorageKey.server, prevServer);
        } else {
            localStorage.removeItem(LocalStorageKey.server);
        }

        krService.login({ userid: "laundry.admin4login@yopmail.com", password: "!Qwer1234" }).then((response) => {
            const loginSessionId = response.account.loginSessionID;

            krApi.getRoleApprovalList({ accessToken: loginSessionId, pageSize: 1000, apprStat: "N" }).then((resp) => {
                const currentUser = resp.role.roleApprList.filter(
                    (user) => user.usrNo === localStorage.getItem(LocalStorageKey.userNo)
                )[0];

                if (currentUser === undefined) return;

                krApi.processRole({
                    accessToken: loginSessionId,
                    usrNo: localStorage.getItem(LocalStorageKey.userNo),
                    seqNo: currentUser.seqNo,
                    apprFlag: "Y",
                    compCnt: "기본 승인",
                });
            });
        });
    }, [api, service]);

    return (
        <AuthContentWrapper
            contentPadding={"20px 40px"}
            overflowX={"visible"}
            contentMinHeight={"240px"}
            header={
                <>
                    <CustomIcon iconName={"undo"} size={"36px"} onClick={redirectToLMPLogin} cursor={"pointer"} />
                    <SizedBox height={"6px"} />
                    <Column justifyContent={"center"}>
                        <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                            Account Type
                        </T1Text>
                        <SizedBox height={"10px"} />
                        <C2Text fontColor={Theme.color.gray500}>
                            Let us know if your store is part of a franchise.
                        </C2Text>
                        <SizedBox height={"44px"} />
                    </Column>
                </>
            }
            footer={
                <>
                    <SizedBox height={"28px"} />
                    <FullWidthButton onClick={handleChangeRole} text={"Ok"} isActive={true} />
                    <SizedBox height={"10px"} />
                    <FullWidthButton
                        onClick={() => setIsCancelPopupOpen(true)}
                        text={"Cancel"}
                        backgroundColor={Theme.color.white}
                        isActive={true}
                    />
                    <SizedBox height={"20px"} />
                    <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                        <C3Text fontColor={Theme.color.gray500}>
                            Copyright © LG Electronics. All Rights Reserved.
                        </C3Text>
                    </Row>
                    <SizedBox height={"20px"} />
                </>
            }
        >
            <Column justifyContent={"flex-start"} alignItem={"flex-start"} overflow={"visible"}>
                <C2Text fontWeight={"500"}>Franchise Y/N</C2Text>
                <SizedBox height={"15px"} />
                <CustomRadios
                    options={[
                        { value: "y", label: "Yes" },
                        { value: "n", label: "No" },
                    ]}
                    selectedOption={isFranchise}
                    setSelectedOption={setIsFranchise}
                />
                {isFranchise === "y" && (
                    <>
                        <SizedBox height={"30px"} />
                        <C2Text fontWeight={"500"}>Franchise Code</C2Text>
                        <SizedBox height={"6px"} />
                        <CustomInput
                            type={"normal"}
                            placeholder={"Enter Franchise Code"}
                            padding={"14px 16px"}
                            inputValue={franchiseCode}
                            setInputValue={setFranchiseCode}
                            isValid={isErrorText}
                            errorText={"Please enter a valid franchise code."}
                        />
                        <SizedBox height={"15px"} />
                        <C2Text fontWeight={"500"}>User Type</C2Text>
                        <SizedBox height={"6px"} />
                        <CustomInput
                            type={"select"}
                            placeholder={"Enter Franchise Code"}
                            dropdownValues={[
                                { label: "Franchise Admin", value: "franchiseAdmin" },
                                { label: "Call Center", value: "callCenter" },
                                { label: "Shop Owner", value: "shopOwner" },
                            ]}
                            padding={"14px 16px"}
                            inputValue={userType}
                            setInputValue={setUserType}
                            noBlur={true}
                        />
                    </>
                )}
            </Column>
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
            <CustomPopup
                isOpen={isErrorPopupOpen}
                onConfirm={() => setIsErrorPopupOpen(false)}
                message={"Please enter a valid franchise code."}
            />
        </AuthContentWrapper>
    );
}

export default RoleChoicePage;
